import { render, staticRenderFns } from "./AssessmentGroupCompEgrPro.vue?vue&type=template&id=67dcab68&scoped=true"
import script from "./AssessmentGroupCompEgrPro.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupCompEgrPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcab68",
  null
  
)

export default component.exports